import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ActivityTypeRepositoryInterface } from "../repositories/activity-type/activity-type.interface";
import { ActivityTypeResponseDto } from "../../common/dtos/activity-type/activity-type.response";

@Injectable({
  providedIn:"root"
})
export class ActivityTypeManager {

  constructor(
        private activityTypeRepository: ActivityTypeRepositoryInterface
  ) {}

  public getActivities(lang : string): Observable<ActivityTypeResponseDto> {
    return this.activityTypeRepository.getActivities(lang);
  }

}